import axios from 'axios';
import Box from '@mui/material/Box';
import Loader from 'react-loader-spinner';
import Link from '@mui/material/Link';
import { useHistory } from 'react-router';
import Alert from '@mui/lab/Alert';
import Paper from '@mui/material/Paper';
import { useDropzone } from 'react-dropzone';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';
import {
  classes,
  thumb,
  thumbInner,
  thumbsContainer,
  img,
  fileIconColor,
} from '../styles';

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('lhcfToken');

const DashboardPublishGalleryPhotoPage = () => {
  const history = useHistory();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    warningOpen: false,
    errorOpen: false,
    successOpen: false,
    vertical: 'center',
    horizontal: 'center',
  });
  const [image, setImage] = useState({
    title: '',
    description: '',
  });

  const { warningOpen, successOpen, errorOpen, vertical, horizontal } =
    snackbarState;

  const handleClose = () => {
    setSnackbarState({
      ...snackbarState,
      warningOpen: false,
      errorOpen: false,
      successOpen: false,
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt="new item" />
      </div>
    </div>
  ));

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/dashboard"
      onClick={() => history.push('/dashboard')}
    >
      Dashboard
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href="/dashboard/gallery-photos/"
      onClick={() => history.push('/dashboard/gallery-photos')}
    >
      Gallery Photos
    </Link>,
    <Typography key="3" color="text.primary">
      Publish Photo
    </Typography>,
  ];

  const handleInputChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;

    setImage({ ...image, [key]: value });
  };

  const handleSubmission = (e) => {
    e.preventDefault();

    if (!files.length) {
      return setSnackbarState({ ...snackbarState, warningOpen: true });
    }

    setLoading(true);

    const formData = new FormData();

    formData.append('title', image.title);
    formData.append('description', image.description);
    formData.append('image', files[0]);

    axios
      .post(`${baseUrl}/gallery`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then(
        ({
          data: {
            data: { _id },
          },
        }) => {
          setSnackbarState({ ...snackbarState, successOpen: true });
          setLoading(false);
          setImage({
            title: '',
            description: '',
          });
          setFiles([]);
          setTimeout(() => {
            history.push(`/dashboard/gallery-photos/${_id}`);
          }, 5000);
        }
      )
      .catch((err) => {
        console.log(err);
        setSnackbarState({ ...snackbarState, errorOpen: true });
        setLoading(false);
      });
  };

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        <Snackbar
          open={warningOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={handleClose}
            severity="warning"
            sx={{ width: '100%' }}
          >
            Image is required. Upload an image.
          </Alert>
        </Snackbar>
        <Snackbar
          open={errorOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            Could not publish the image. Try again.
          </Alert>
        </Snackbar>
        <Snackbar
          open={successOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: '100%' }}
          >
            Image published successfully!
          </Alert>
        </Snackbar>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
        <Box
          sx={classes.paperContainer}
          component="form"
          onSubmit={handleSubmission}
        >
          <Paper elevation={4} variant="outlined" square>
            <TextField
              id="filled-basic"
              label="Title"
              name="title"
              variant="filled"
              value={image.title}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="standard-multiline-static"
              label="Description"
              name="description"
              multiline
              rows={5}
              variant="filled"
              value={image.description}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <section style={{ width: '400px' }}>
              <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <AttachFileIcon style={fileIconColor} />
                <p>Drag and drop image file here, or click to select file *</p>
              </div>
              <aside style={thumbsContainer}>{thumbs}</aside>
            </section>

            <br />

            <Box sx={classes.buttonsContainer}>
              {loading ? (
                <Button variant="contained" color="primary" disabled>
                  <Loader type="Oval" color="#1976d2" height={30} width={50} />
                </Button>
              ) : (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={classes.buttonMargin}
                    type="submit"
                  >
                    Publish
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => history.push('/dashboard/gallery-photos')}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardPublishGalleryPhotoPage;
